export var spacer = {
    spacing0: '1px',
    spacing1: '4px',
    spacing2: '0.5rem',
    spacing3: '0.75rem',
    spacing4: '1rem',
    spacing5: '1.25rem',
    spacing6: '1.5rem',
    spacing7: '1.75rem',
    spacing8: '2rem',
    spacing9: '2.25rem',
    spacing10: '2.5rem',
    spacing11: '3rem',
    spacing12: '3.5rem',
    spacing13: '4rem',
    spacing14: '5rem',
    spacing15: '6rem',
    spacing16: '7rem',
    spacing17: '8rem',
    spacing18: '9rem',
    spacing19: '10rem',
    spacing20: '11rem',
    spacing21: '12rem',
    spacing22: '13rem',
    spacing23: '14rem',
    spacing24: '15rem',
    spacing25: '16rem',
    spacing26: '18rem',
    spacing27: '20rem',
    spacing28: '24rem'
};
